import * as React from 'react'
import ImageView from '../../../../../ui/ImageView'
import { IProviderProductObject } from '../../../../../../types'
import { isValidURL } from 'src/utils/validators'
import { capitalToUpperCase } from 'src/utils'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import FormLabel from 'src/components/ui/form/FormLabel'

export interface IProviderInfoItemProps {
  product: IProviderProductObject
}

// NOTE: Using IProviderListItemProps to expect riders membership
// We have to make these type consistent across the application

const ProductInfoPane = ({ product }: IProviderInfoItemProps) => {
  if (!product) {
    return null
  }
  const serviceLevel = product.providerServiceLevel ? product.providerServiceLevel.name : 'Not Specified'

  let externalURL
  if (product.externalUrl !== undefined && isValidURL(product.externalUrl)) {
    externalURL = (
      <a href={product.externalUrl} target='_blank'>
        {product.externalUrl}
      </a>
    )
  } else {
    externalURL = product.externalUrl
  }

  return (
    <FloatingForm fullHeight={true}>
      <>
        <div className='form-modal-section full-section'>
          <div className='flex'>
            <FormLabel>Product Information</FormLabel>
          </div>

          <div className='bb-shadow-grey'>&nbsp;</div>

          <div style={{ height: '82px' }} className='flex flex-row'>
            <div className='flex flex-column justify-center'>
              <ImageView name={product.name} entityId={product.id} />
            </div>
          </div>

          <div className='flex column-gap-16'>
            <div className='col-6'>
              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Product Name</FormLabel>
                  <div className='mt1 h5'>{product.name || 'None'}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Product Description</FormLabel>
                  <div className='mt1 h5'>{product.description || 'None'}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Service Level</FormLabel>
                  <div className='mt1 h5'>{serviceLevel || 'None'}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Internal Name</FormLabel>
                  <div className='mt1 h5'>{product.internalName || 'None'}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Allotted Loading Time</FormLabel>
                  <div className='mt1 h5'>{product.estimatedLoadingTime || 'None'}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Allotted Time at Pickup</FormLabel>
                  <div className='mt1 h5'>{`${product.allottedTimeAtPickup} ${
                    Number(product.allottedTimeAtPickup) <= 1 ? 'minute' : 'minutes'
                  }`}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Allotted Time at Drop-off</FormLabel>
                  <div className='mt1 h5'>{`${product.allottedTimeAtDropoff} ${
                    Number(product.allottedTimeAtDropoff) <= 1 ? 'minute' : 'minutes'
                  }`}</div>
                </div>
              </div>
            </div>
            <div className='col-6'>
              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>External URL</FormLabel>
                  <div className='mt1 h5'>{externalURL || 'None'}</div>
                </div>
              </div>
              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Booking Priority</FormLabel>
                  <div className='mt1 h5'>{capitalToUpperCase(product.bookingPriority) || 'None'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </FloatingForm>
  )
}

export default ProductInfoPane



// WEBPACK FOOTER //
// ./src/components/products/details/product/details/pane/ProductInfo.tsx